import { sv } from 'date-fns/locale'
import type { LocaleData } from '@/types'

export const defaultLocale: LocaleData = {
  module: sv,
  code: {
    short: 'sv',
    long: 'svSE',
    full: 'sv-SE'
  }
}
